var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"t-reviews-list-course"},[_c('div',{staticClass:"t-reviews-list-course__items"},_vm._l((_vm.reviews.items),function(item,index){return _c('cmp-reviews',{key:'reviews_' + index,attrs:{"data":item}})}),1),_vm._v(" "),(_vm.reviews._meta.pageCount > 1)?_c('cmp-pagination',{staticClass:"t-reviews-list-course_comments",attrs:{"pages":_vm.reviews._meta.pageCount}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70a04b7c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue_components/Courses/ReviewList.vue
// module id = 340
// module chunks = 0